import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { FaqModel } from './models/faq-models';
import { FaqService } from './services/faq.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  public faqEntries!: Array<FaqModel>;
  private subscriptions = new Subscription();

  constructor(
    private faqService: FaqService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(
      this.faqService.getFaq().subscribe((faqEntries:FaqModel[]) => this.faqEntries = faqEntries)
    );
  }

  ngOnDestroy(){
    this.subscriptions.unsubscribe();
  }
}
